import "core-js/modules/es.array.slice.js";
import React from 'react';
import Box from 'components/Box';
import SmartBillboard from '../../shared/smartBillboard';
import SmartBillboardShared from '../../shared/smartBillboardShared';
import CollectionCarousel from './CollectionCarousel';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export var BillboardAndCarousel = function BillboardAndCarousel(_ref) {
  var items = _ref.items,
    isShared = _ref.isShared,
    qaIdContext = _ref.qaIdContext;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [isShared ? /*#__PURE__*/_jsx(SmartBillboardShared, {
      item: items[0]
    }) : /*#__PURE__*/_jsx(SmartBillboard, {
      item: items[0]
    }), items.length > 1 && /*#__PURE__*/_jsx(Box, {
      pt: "l",
      children: /*#__PURE__*/_jsx(CollectionCarousel, {
        large: true,
        items: items.slice(1),
        isShared: isShared,
        qaIdContext: qaIdContext
      })
    })]
  });
};
export default BillboardAndCarousel;